export default __webpack_public_path__ + "static/media/plus.7225810c.svg";